module.exports = __webpack_public_path__ + "static/img/logo12.93d1807.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo12.png
// module id = 404
// module chunks = 2